import React from 'react';
import { cx } from '@emotion/css';
import { photoTableImg } from './quizApp.style';

function CorrectAnswers(props) {
  const selectedAnswer = props.selectedanswer || 'Not answered';
  const correctAnswer = props.correctanswer?.trim() || '';
  const alternateAnswers = Array.isArray(props.alternateanswers) ? props.alternateanswers : [];
  const ignoreCases = props.ignorecases === 'true';

  const isCorrect =
    selectedAnswer === correctAnswer ||
    alternateAnswers.includes(selectedAnswer.trim()) ||
    (ignoreCases && selectedAnswer.toLowerCase() === correctAnswer.toLowerCase()) ||
    (ignoreCases && alternateAnswers.map(word => word.toLowerCase()).includes(selectedAnswer.toLowerCase().trim()));

  return (
    <tr>
      <td>
        {props.eventtype === 'ImagewithTextField' ? (
          <img className={cx(photoTableImg)} src={props.question} alt="Question" />
        ) : (
          props.question
        )}
      </td>
      <td>{correctAnswer}</td>
      <td>{selectedAnswer}</td>
      <td>
        {isCorrect ? (
          <img height="40" width="40" src="../assets/pass.png" alt="Pass" />
        ) : (
          <img height="40" width="40" src="../assets/fail.png" alt="Fail" />
        )}
      </td>
      <td>
        <button
          onClick={() => {
            props.selected?.(props.questionid);
          }}
        >
          <img src={require('../assets/images/email.png').default} alt="Email" />
        </button>
      </td>
    </tr>
  );
}

export default CorrectAnswers;